import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const fleetPlugin = createPlugin({
  id: 'fleet',
  routes: {
    root: rootRouteRef,
  },
});

export const FleetPage = fleetPlugin.provide(
  createRoutableExtension({
    name: 'FleetPage',
    component: () =>
      import('./components/FleetComponent').then(m => m.FleetComponent),
    mountPoint: rootRouteRef,
  }),
);
